export default __webpack_public_path__ + "4d187926486569b882e93e10caefe91c.jpg";